import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import CrossAssetAnalysisComponent from './CrossAssetAnalysisComponent';
import { withErrorBoundaryTrigger } from 'sharedComponents/ErrorBoundary';
import { createErrorDataSelector } from 'selectors/selectorUtils';

// Only KPI list errors trigger the top-level full-page ErrorBoundary.
// Chart errors are handled inline in ChartViewComponent (right panel only).
const getKpiListError = ({ crossAssetAnalysisSidepanel }) => ({
    loadingStatus: crossAssetAnalysisSidepanel?.kpiList?.loadingStatus,
    error: crossAssetAnalysisSidepanel?.kpiList?.error,
    errorCode: crossAssetAnalysisSidepanel?.kpiList?.error?.statusCode
});

const getKpiListErrorData = createErrorDataSelector(getKpiListError);

const getModel = createSelector(
    [getKpiListErrorData],
    (kpiListErrorData) => ({
        kpiListErrorData
    })
);

const CrossAssetAnalysisContainer = () => {
    return <CrossAssetAnalysisComponent />;
};

const mapStateToProps = (state) => ({
    model: getModel(state)
});

const CrossAssetAnalysisContainerWithErrorBoundaryTrigger = withErrorBoundaryTrigger(CrossAssetAnalysisContainer);

export default connect(mapStateToProps)(CrossAssetAnalysisContainerWithErrorBoundaryTrigger);
